// extracted by mini-css-extract-plugin
export default {"settings":"settings_settings__XxKSr","title":"settings_title__7OnZn"};